import { createContext, useReducer } from 'react'
import { type MapProviderProps, type MapDataContextProps, type MapDispatchContextProps } from 'src/types'

import { reducer } from './reducer'
import { defaultMapState } from './defaults'

export const MapDataContext = createContext<MapDataContextProps>({ map: defaultMapState })
MapDataContext.displayName = 'MapDataContext'

export const MapDispatchContext = createContext<MapDispatchContextProps>({ dispatchMap: () => null })
MapDispatchContext.displayName = 'MapDispatchContext'

export const MapProvider = ({ children }: MapProviderProps) => {
  const [map, dispatchMap] = useReducer(reducer, defaultMapState)
  
  return (
    <MapDataContext.Provider value={{ map }}>
      <MapDispatchContext.Provider value={{ dispatchMap }}>
        {children}
      </MapDispatchContext.Provider>
    </MapDataContext.Provider>
  )
}
